/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CreateLocationGroupsRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class LocationGroupsMassCreates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name CreateLocationGroups
   * @request POST:/locationGroups-mass-creates
   * @secure
   */
  createLocationGroups = (data: CreateLocationGroupsRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/locationGroups-mass-creates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsLocationGroupsMassCreates
   * @request OPTIONS:/locationGroups-mass-creates
   */
  optionsLocationGroupsMassCreates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/locationGroups-mass-creates`,
      method: 'OPTIONS',
      ...params,
    });
}
